// Injeta o loader do Google Charts sob demanda (Task 9) — antes era carregado
// por script tag bloqueante em app/views/layouts/application.html.slim, em
// toda página do sistema. Promise memoizada: a segunda chamada reaproveita o
// script já injetado, não duplica a tag.
let promise;

export default function loadGoogleCharts() {
  if (promise) return promise;

  promise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://www.gstatic.com/charts/loader.js';
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });

  return promise;
}
